import {
    DEALERAGENTDOWNLOADSAMPLEFILE_FAILED,
    DEALERAGENTDOWNLOADSAMPLEFILE_SUCCESS,
    RESET_DEALERAGENTDOWNLOADSAMPLEFILE,
    LOADING_DEALERAGENTDOWNLOADSAMPLEFILE,
    NETWORK_ERROR_DEALERAGENTDOWNLOADSAMPLEFILE
} from '../types/index'

import { dealerServices } from "../../config/axios";
const resetDealerAgentDownloadSampleFile = () => {
    return { type: RESET_DEALERAGENTDOWNLOADSAMPLEFILE };
};

const dealerAgentSampleDownloadFile = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERAGENTDOWNLOADSAMPLEFILE });
    await dealerServices
        .post("agentDownloadSampleFile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAgentDownloadSampleFilesuccess(res.data));
                    break;
                default:
                    dispatch(dealerAgentDownloadSampleFileFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERAGENTDOWNLOADSAMPLEFILE,
                payload: err
            });
        });
};

function dealerAgentDownloadSampleFilesuccess(data) {
    return {
        type: DEALERAGENTDOWNLOADSAMPLEFILE_SUCCESS,
        payload: data
    };
}
function dealerAgentDownloadSampleFileFailed(data) {
    return {
        type: DEALERAGENTDOWNLOADSAMPLEFILE_FAILED,
        payload: data
    };
}
export { resetDealerAgentDownloadSampleFile, dealerAgentSampleDownloadFile }